import { setProjectOverview, setProjectOverviews } from "reduxStore/state";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getProjectOverviews = () => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(`${BASE_URL}/project-overview`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to get project overviews");
    }

    const projectOverviews = await response.json();

    dispatch(setProjectOverviews(projectOverviews)); // Dispatch the action to update the state

    return projectOverviews;
  } catch (error) {
    console.error("Error while getting project overviews:", error);
    return null;
  }
};

export const getProjectOverviewById = (id) => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(`${BASE_URL}/project-overview/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to get project overview");
    }

    const projectOverview = await response.json();

    dispatch(setProjectOverview(projectOverview)); // Dispatch the action to update the state

    return projectOverview;
  } catch (error) {
    console.error("Error while getting project overview:", error);
    return null;
  }
};

export const createProjectOverview =
  (projectOverview) => async (dispatch, getState) => {
    try {
      const token = getState().token;

      const response = await fetch(`${BASE_URL}/project-overview`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(projectOverview),
      });

      if (!response.ok) {
        throw new Error("Failed to create project overview");
      }

      const newProjectOverview = await response.json();

      dispatch(setProjectOverview(newProjectOverview)); // Dispatch the action to update the state

      // Fetch all project overviews to update the list
      dispatch(getProjectOverviews()); // Refresh the list of project overviews

      return newProjectOverview;
    } catch (error) {
      console.error("Error while creating project overview:", error);
      return null;
    }
  };

export const updateProjectOverview =
  (projectOverview) => async (dispatch, getState) => {
    try {
      const token = getState().token;

      const response = await fetch(
        `${BASE_URL}/project-overview/${projectOverview._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(projectOverview),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update project overview");
      }

      const updatedProjectOverview = await response.json();

      dispatch(setProjectOverview(updatedProjectOverview)); // Dispatch the action to update the state

      return updatedProjectOverview;
    } catch (error) {
      console.error("Error while updating project overview:", error);
      return null;
    }
  };

export const deleteProjectOverview = (id) => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(`${BASE_URL}/project-overview/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to delete project overview");
    }

    // Optionally, you can dispatch an action to remove the deleted project overview from the state
    dispatch(getProjectOverviews()); // Refresh the list of project overviews

    return { message: "Project overview deleted successfully" };
  } catch (error) {
    console.error("Error while deleting project overview:", error);
    return null;
  }
};
